/**
 * Flight and Hotel Bundle Reducer
 * Manages the state for flight + hotel bundle pricing
 */

import {
  FLIGHT_AND_HOTEL_BUNDLE_UPDATE_FLIGHT_DATA,
  FLIGHT_AND_HOTEL_BUNDLE_UPDATE_SELECTED_DATES,
  FLIGHT_AND_HOTEL_BUNDLE_RESET,
} from 'actions/FlightAndHotelBundleActions'
import { createAppReducer } from 'lib/redux/reducerUtils'

export const initialFlightAndHotelBundleState: App.FlightAndHotelBundleState = {
  flightData: {
    fetching: false,
  },
  selectedDates: {
    checkIn: '',
    checkOut: '',
  },
}

const flightAndHotelBundleReducer = createAppReducer<App.FlightAndHotelBundleState>(initialFlightAndHotelBundleState, {
  [FLIGHT_AND_HOTEL_BUNDLE_UPDATE_FLIGHT_DATA]: (state, action) => ({
    flightData: {
      ...state.flightData,
      ...action.payload,
    },
  }),

  [FLIGHT_AND_HOTEL_BUNDLE_UPDATE_SELECTED_DATES]: (state, action) => ({
    selectedDates: action.payload,
  }),

  [FLIGHT_AND_HOTEL_BUNDLE_RESET]: () => initialFlightAndHotelBundleState,
})

export default flightAndHotelBundleReducer
